import BubblePlot from "./BubblePlot";
export default BubblePlot;
export { parseBubblePlotData, fetchBubblePlotData } from "./data-api";
